import React, { useState, useEffect } from 'react';
import './FallaInfoComponent.css';
import { EventCalendar } from '../Ejercicio/EventCalendar';
import LogoScroller from "../Patrocinadores/LogoScroller";
import { GetInstagramNews, GetMainSponsors } from '../../Backend/ApiCalls';

export const FallaInfo = (props) => {
    const [latestPost, setLatestPost] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [mainSponsors, setMainSponsors] = useState([]);
    const [specialCollaborators, setSpecialCollaborators] = useState([]);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    const fetchLatestInstagramPost = async () => {
        try {
            const { response, data } = await GetInstagramNews(1);
            if (!response.ok) {
                throw new Error(data?.Error || 'No se pudo cargar la ultima noticia');
            }
            setLatestPost(Array.isArray(data?.data) ? data.data[0] || null : null);
        } catch (error) {
            console.error('Error fetching the latest Instagram post:', error);
        }
    };

    useEffect(() => {
        fetchLatestInstagramPost();
    }, []);

    useEffect(() => {
        let cancelled = false;
        const loadMainSponsors = async () => {
            try {
                const { response, data } = await GetMainSponsors();
                if (!response.ok || !Array.isArray(data)) throw new Error('No se pudieron cargar los patrocinadores principales');
                const mapped = data
                    .filter((item) => item.active !== false && item.image)
                    .sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
                    .map((item) => ({ src: item.imageUrl || item.image, alt: item.name, href: item.url || undefined, type: item.type === 'special' ? 'special' : 'main' }));
                if (!cancelled) {
                    setMainSponsors(mapped.filter((item) => item.type === 'main'));
                    setSpecialCollaborators(mapped.filter((item) => item.type === 'special'));
                }
            } catch (error) {
                console.warn('No se pudieron cargar los patrocinadores principales.', error);
            }
        };
        loadMainSponsors();
        return () => { cancelled = true; };
    }, []);

    const formatDate = (date) => {
        const options = { day: '2-digit', month: 'long', year: 'numeric' };
        return new Date(date).toLocaleDateString('es-ES', options);
    };

    const renderLatestPostMedia = (post) => {
        if (!post) return null;

        if (post.media_type === 'VIDEO') {
            return (
                <div className="home-news-media home-news-media--video">
                    <video controls playsInline preload="metadata" poster={post.thumbnail_url || ""} aria-label={props.I18n.InstagramVideo || 'Vídeo de Instagram'}>
                        <source src={post.media_url} type="video/mp4" />
                        {props.I18n.VideoNotSupported}
                    </video>
                </div>
            );
        }

        return (
            <a href={post.media_url} className="home-news-media">
                <img src={post.thumbnail_url || post.media_url} alt={post.caption || props.I18n.InstagramPost || 'Publicación de Instagram'} />
            </a>
        );
    };

    return (
        <div className="FallaInfoComponent">
            <div className="info-mapa-section">
                <div className="informacionGeneral">
                    <h1>{props.I18n.GeneralInformation}</h1>
                    <ul>
                        <li><span>{props.I18n.ComissionNumber}:</span> 37</li>
                        <li><span>{props.I18n.CasalFallero}:</span> C/Luis Vives,43</li>
                        <li><span>{props.I18n.Monument}:</span> Plaza Rodrigo</li>
                        <li><span>{props.I18n.Founded}:</span> 1991</li>
                        <li><span>{props.I18n.NumberOfFalleros}:</span> 508</li>
                        <li><span>{props.I18n.Sector}:</span> Sector I</li>
                        <li><span>{props.I18n.Section}:</span> Especial</li>
                        <li><span>{props.I18n.Contact}:</span> contacto@fallaplazarodrigo.es</li>
                    </ul>
                </div>
                <iframe
                    title={props.I18n.Map || 'Mapa'}
                    className="mapa"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6142.959101201634!2d-0.220344!3d39.661426!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd60160604d7dcef%3A0x196a955cbdb42d4f!2sCarrer%20Llu%C3%ADs%20Vives%2C%2043%2C%2046520%20Port%20de%20Sagunt%2C%20Val%C3%A8ncia%2C%20Espa%C3%B1a!5e0!3m2!1ses!2sus!4v1712618284953!5m2!1ses!2sus"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>

            {mainSponsors.length > 0 && <>
                <h1 className="titulo-page" style={{ marginTop: 24 }}>{props.I18n.MainSponsors || 'Patrocinadores principales'}</h1>
                <LogoScroller logos={mainSponsors} label={props.I18n.MainSponsors || 'Patrocinadores principales'} />
            </>}
            {specialCollaborators.length > 0 && <>
                <h2 className="titulo-page">{props.I18n.SpecialCollaborators || 'Colaboradores especiales'}</h2>
                <LogoScroller logos={specialCollaborators} label={props.I18n.SpecialCollaborators || 'Colaboradores especiales'} className="logo-scroller--special" />
            </>}


            <h1 className="titulo-page">{props.I18n.StayInformed}</h1>
            <div className="event-news-row">
                <div className="event-preview">
                    <h3 className='titulo-page'>{props.I18n.NextEvent}</h3>
                    <EventCalendar renderNextEvent={(event) => (
                        <div className="event-details-container">
                            <div className="event-item">
                                <h4>{event.title}</h4>
                                <div className="event-details">
                                    <p><strong>{props.I18n.Date}:</strong> {formatDate(event.date)}</p>
                                    <p><strong>{props.I18n.Location}:</strong> {event.location}</p>
                                    <p><strong>{props.I18n.Description}:</strong> {event.description}</p>
                                </div>
                            </div>
                            <a href="/calendario-rodrigo" className="view-more-link">
                                {props.I18n.ViewMoreEvents}
                            </a>
                        </div>
                    )} />
                </div>
                <div className="news-preview">
                    <h3 className='titulo-page'>{props.I18n.LastNews}</h3>
                    {latestPost ? (
                        <div className="home-news-card">
                            <p className="home-news-date">{formatDate(latestPost.timestamp)}</p>
                            {renderLatestPostMedia(latestPost)}
                            <p className="home-news-caption">{latestPost.caption}</p>
                            <a href={latestPost.permalink} target="_blank" rel="noopener noreferrer" className="home-news-link">
                                {props.I18n.SeeOnInstagram}
                            </a>
                        </div>
                    ) : (
                        <p>{props.I18n.LoadingNews}</p>
                    )}
                    <a href="/noticias" className="view-more-link">{props.I18n.ViewMoreNews}</a>
                </div>
                
            </div>
            <div className="faq-section">
                    <h1 className="faq-title">{props.I18n.FaqTitle || 'Preguntas frecuentes'}</h1>
                    <div className="faq-item">
                        <button type="button" className="faq-question" onClick={() => toggleFAQ(0)} aria-expanded={activeIndex === 0}>
                            <h2>{props.I18n.FaqQuestion1 || '¿Qué es una falla?'}</h2>
                            <span className={activeIndex === 0 ? 'faq-icon open' : 'faq-icon'}>+</span>
                        </button>
                        {activeIndex === 0 && (
                            <div className="faq-answer">
                                <p>{props.I18n.FaqAnswer1}</p>
                            </div>
                        )}
                    </div>

                    <div className="faq-item">
                        <button type="button" className="faq-question" onClick={() => toggleFAQ(1)} aria-expanded={activeIndex === 1}>
                            <h2>{props.I18n.FaqQuestion2 || '¿Cómo me puedo apuntar a la falla?'}</h2>
                            <span className={activeIndex === 1 ? 'faq-icon open' : 'faq-icon'}>+</span>
                        </button>
                        {activeIndex === 1 && (
                            <div className="faq-answer">
                                <p>{props.I18n.FaqAnswer2}</p>
                            </div>
                        )}
                    </div>

                    <div className="faq-item">
                        <button type="button" className="faq-question" onClick={() => toggleFAQ(2)} aria-expanded={activeIndex === 2}>
                            <h2>{props.I18n.FaqQuestion3 || '¿Es obligatorio vestirse en los actos?'}</h2>
                            <span className={activeIndex === 2 ? 'faq-icon open' : 'faq-icon'}>+</span>
                        </button>
                        {activeIndex === 2 && (
                            <div className="faq-answer">
                                <p>{props.I18n.FaqAnswer3}</p>
                            </div>
                        )}
                    </div>

                    <div className="faq-item">
                        <button type="button" className="faq-question" onClick={() => toggleFAQ(3)} aria-expanded={activeIndex === 3}>
                            <h2>{props.I18n.FaqQuestion4 || '¿Se realizan más actos a lo largo del año aparte de las Fallas?'}</h2>
                            <span className={activeIndex === 3 ? 'faq-icon open' : 'faq-icon'}>+</span>
                        </button>
                        {activeIndex === 3 && (
                            <div className="faq-answer">
                                <p>{props.I18n.FaqAnswer4}</p>
                            </div>
                        )}
                    </div>
                </div>
        </div>
    );
};
